// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1029) return "static/chunks/1029-aa0eba64c9467896.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"6851":"79ff2c8e","8950":"01db7e4b"}[chunkId] || chunkId) + "." + {"1091":"3beb705d456b7633","6851":"6fc1183bf227404b","8596":"7286b39fe1645039","8950":"275e666bd5277c73","9961":"ff88157ab031db7f"}[chunkId] + ".js";
};